/**
 * CastRail — centralized copy strings (AOF 25, i18n posture).
 */

export const castRailCopy = {
  railLabel: "who you are speaking to",
  addLabel: "+ someone",
  addTitle: "who else should be in the room?",
  addPlaceholder: "a lighthouse keeper who has not seen anyone in a month…",
  addInputLabel: "describe someone in one sentence",
  addSubmit: "bring them in",
  addCancel: "never mind",
  /**
   * Two pre-authored one-tap starts. They cost nothing and they are for
   * the visitor who reads "describe someone" and freezes, which is the
   * most common way a blank field ends a demo.
   */
  examples: [
    "a lighthouse keeper who has not seen anyone in a month",
    "a night-shift baker who knows everyone's order and nobody's name",
  ],
  working: "writing them in…",
  addFailed: "that one did not come out. try a different sentence.",
  full: "the room is full",
  lampTitle: (name: string): string => `speak to ${name}`,
} as const;
